module.exports = __webpack_public_path__ + "static/media/rights_contact.407418ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tab-images/rights_contact.jpg
// module id = 213
// module chunks = 0